export type UseCase = "business" | "private";

export interface FormBranchingApi {
  applyInitialUseCase: (useCase: UseCase) => void;
}

export function initFormBranching(form: HTMLFormElement | null): FormBranchingApi {
  const noop: FormBranchingApi = { applyInitialUseCase: () => {} };
  if (!form) return noop;

  const panels = new Map<UseCase, HTMLElement>();
  form.querySelectorAll<HTMLElement>("[data-case]").forEach((el) => {
    const kind = el.dataset.case as UseCase;
    panels.set(kind, el);
    el.hidden = true;
  });

  const apply = (useCase: UseCase) => {
    panels.forEach((el, kind) => {
      el.hidden = kind !== useCase;
    });
  };

  form.addEventListener("change", (e) => {
    const target = e.target as HTMLInputElement | null;
    if (!target || target.name !== "useCase") return;
    apply(target.value as UseCase);
  });

  return {
    applyInitialUseCase(useCase) {
      const radio = form.querySelector<HTMLInputElement>(
        `input[name="useCase"][value="${useCase}"]`,
      );
      if (radio) radio.checked = true;
      apply(useCase);
    },
  };
}
